import { EventData } from '../common/interfaces';
import { InternalEvents } from '../events';
import { NodeInfo } from '../webrtc/agent/kernelInterfaces';

export interface NodeUpdateEvent extends EventData {
  type: InternalEvents.NODE_UPDATE;
  data: {
    node: NodeInfo;
  };
}
export default function nodeUpdateEvent(node: NodeInfo): NodeUpdateEvent {
  return { type: InternalEvents.NODE_UPDATE, data: { node } };
}
